import { render, staticRenderFns } from "./HistorySavedView.vue?vue&type=template&id=76354472"
import script from "./HistorySavedView.vue?vue&type=script&lang=ts"
export * from "./HistorySavedView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports